import React, { useEffect, useState } from 'react'
import { KYCDocumentsPresenter } from './kyc-documents-presenter'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { documentServices, kycServices } from '../../services'
import { KYCDocumentsChecklist, KYCUploadedDocument } from '../../lib/types'

const KYCDocumentsContainer = () => {
  const { authToken, userId } = useSelector((state: RootState) => state.investor)
  const [kycDocumentsChecklist, setKYCDocumentsChecklist] = useState<KYCDocumentsChecklist>({
    isEmailVerified: false,
    isNdaAccepted: false,
    isInvestmentEssentialsAgreementAccepted: false,
    isTobAccepted: false,
    isTransactionChecklistAgreementAccepted: false,
    clientAgreementDocumentId: null,
    welcomeLetter: null,
    selfDeclaration: false,
    kycStatus: 'NOT_STARTED',
    kycDocuments: [],
  })

  useEffect(() => {
    const getKYCDocumentsChecklist = async () => {
      const response = await kycServices.getInvestorKYCDocumentsChecklist(userId, {
        Authorization: authToken ? authToken : '',
      })
      if (response && response.data && response.status === 200) {
        setKYCDocumentsChecklist(response.data)
      }
    }

    if (authToken) {
      getKYCDocumentsChecklist()
    }
  }, [])

  const getAccessToken = async () => {
    const response = await documentServices.getAccessToken({
      Authorization: authToken ? authToken : '',
    })

    if (response.status === 200 && response.data) {
      return response.data
    }

    return ''
  }

  const handleWelcomeLetterDownload = (welcomeLetterLink: string) => {
    window.open(welcomeLetterLink)
  }

  const handleClientAgreementDownload = async (clientAgreementLink: string) => {
    const accessToken = await getAccessToken()

    if (accessToken) {
      const response = await documentServices.getDownloadLink(accessToken, clientAgreementLink, {
        Authorization: authToken ? authToken : '',
      })

      if (response.status === 200 && response.data) {
        window.open(response.data)
      }
    }
  }

  // REMOVED: handleSelfDeclarationDownload - self-declaration now handled via client agreement

  const handleSumsubKYCDocumentDownload = async (sumsubDocument: KYCUploadedDocument | null) => {
    if (!sumsubDocument || !sumsubDocument.documentData) {
      return
    }

    const {
      documentData: { id },
    } = sumsubDocument

    const response = await kycServices.getSumsubDocument(userId, id, {
      Authorization: authToken ? authToken : '',
    })

    if (response.status === 200 && response.data) {
      const { type } = response.data
      const fileType = type.split('/')
      const url = window.URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = url
      a.download = `download.${fileType[fileType.length - 1]}`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    }
  }

  return (
    <KYCDocumentsPresenter
      kycDocumentsChecklist={kycDocumentsChecklist}
      handleWelcomeLetterDownload={handleWelcomeLetterDownload}
      handleClientAgreementDownload={handleClientAgreementDownload}
      handleSumsubKYCDocumentDownload={handleSumsubKYCDocumentDownload}
    />
  )
}

export { KYCDocumentsContainer }
